import React from 'react';

const NotFound = () => {
  return <h1 align='center'>Sorry there's nothing here</h1>;
};

export default NotFound;
